module.exports = __webpack_public_path__ + "img/MCB-r1.847df84b.gif";